<template>
  <div :key="$i18n.locale" class="pt-4 flex flex-wrap">
    <div class="w-full h-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <template :key="key" v-for="(service, key) in services">
        <ServiceCardVue
          :label="service.localizedServiceName"
          :serviceId="service.transactionId"
          :can-share="false"
        >
          <template #start-service>
            <StartButton :service="{ ...service, serviceId: service.transactionId }" />
          </template>
          <template #applicationTracking>
            <RouterLink
              :to="{ name: 'PublicVisaApplicationTracking' }"
              class="w-fit px-2 rounded-md bg-primary/80 hover:bg-primary flex items-center justify-between hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed font-normal"
            >
              <span class="ltr:font-sans tracking-wide text-white text-xs pb-[1px]">
                {{ $t('applicationTrackingMenu') }}
              </span>
            </RouterLink>
          </template>
        </ServiceCardVue>
      </template>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref, watch, nextTick, onMounted } from 'vue'
import { useGlobalStore } from '@/stores/global'
import lookups from '@/assets/json/clientLookups.json'
import ServiceCardVue from '@/components/cards/ServiceCard.vue'
import StartButton from '@/components/Buttons/Service/StartButton.vue'

const i18n = useI18n()

const globalStore = useGlobalStore()

const services = ref([])

watch(i18n.locale, async () => {
  await globalStore.getServicesList()
  await nextTick()
  await getPublicVisaServices()
})

onMounted(async () => {
  await nextTick()
  await getPublicVisaServices()
})

async function getPublicVisaServices() {
  if (globalStore.rawModules.length === 0) {
    await globalStore.getServicesList()
  }
  const output = []

  globalStore.rawModules.forEach((module) => {
    // if (module.localizedName == 'Additional Serivces') {
    //   var jsonForAdditionalServices = module.description
    //   $scope.additionalServices = angular.fromJson(jsonForAdditionalServices)
    //   return
    // }
    if (module.localizedName == 'Additional Serivces') return

    module.moduleServices.forEach((parentService) => {
      parentService.childs.forEach((subService) => {
        subService.serviceTransactions.forEach((transaction) => {
          const serviceNameAsList = [
            module.localizedName,
            parentService.localizedName,
            subService.localizedName,
            transaction.localizedName
          ]

          /**
           * applicableIds. a rework of this monstrosity
           * transaction.id == lookups.ServiceTransactions.issueVisaForIndianNationalsWithSpecialVisas
           *  || transaction.id == lookups.ServiceTransactions.sixmonthsToFinalizeTheProceduresOfGoldenResidency
           *  || transaction.id == lookups.ServiceTransactions.longTerm5YearsMultiEntry
           *  || transaction.id == lookups.ServiceTransactions.issueNewVisaForVirtualWorkWorker
           *  || transaction.id == lookups.ServiceTransactions.issueVisaNationalsExemptionsCountriesEntryPermission
           *  || transaction.id == lookups.ServiceTransactions.longTerm5YearsMultiEntryFamilyGroup
           */

          const applicableIds = [
            lookups.ServiceTransactions.issueVisaForIndianNationalsWithSpecialVisas,
            lookups.ServiceTransactions.sixmonthsToFinalizeTheProceduresOfGoldenResidency,
            lookups.ServiceTransactions.longTerm5YearsMultiEntry,
            lookups.ServiceTransactions.issueNewVisaForVirtualWorkWorker,
            lookups.ServiceTransactions.issueVisaNationalsExemptionsCountriesEntryPermission,
            lookups.ServiceTransactions.longTerm5YearsMultiEntryFamilyGroup
          ]

          if (applicableIds.includes(transaction.id)) {
            output.push({
              localizedServiceName: serviceNameAsList.join(' - '),
              moduleId: module.id,
              transactionId: transaction.id,
              favactive: ''
            })
          }
        })
      })
    })
  })

  services.value = output
}
</script>

<style lang="scss" scoped></style>
